import React, { useEffect, useState } from 'react'
import StateContext from './StateContext'

const State = (props) => {

  const [modal, setModal] = useState({ open: false, component: '' });
  const [confirm, setConfirm] = useState({ component: "", ticketId: '', text: '' });
  const [ticket, setTicket] = useState({ title: '', description: '' });
  const [tickets, setTickets] = useState([]);
  const token = localStorage.getItem("token")
  const [ticketIds, setTicketIds] = useState({ id: '', clientId: '', employeeId: '' });
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState({ open: false, text: '' });
  const [detail, setDetail] = useState({ open: false, data: '' });
  const [FCM_token, setFCM_token] = useState('');
  const [allTickets, setAllTickets] = useState([]);
  const [reminderData, setReminderData] = useState(null);
  const [success, setSuccess] = useState(false);
  const [groups, setGroups] = useState([]);
  const [groupDetails, setGroupDetails] = useState(null); // State to hold group details
  const [delayRequest, setDelayRequest] = useState(false)
  const [userUpdateId, setUserUpdateId] = useState(null); // State to hold user id for profile update
  const [sortOrder, setSortOrder] = useState('desc'); // Default sorting order (asc or desc)
  const [toDate, setToDate] = useState(new Date());
  const [sortBy, setSortBy] = useState('date'); // Default sorting field
  const [filterItem, setFilterItem] = useState([]);
  const [filter, setFilter] = useState("Assigned_to");
  const [filters, setFilters] = useState({});
  const [notifications, setNotifications] = useState([]);
  const [detailModal, setDetailModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalTickets, setTotalTickets] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [hasMore, setHasMore] = useState(true); 
  const [fetching, setFetching] = useState(false); 
  const [load, setLoad] = useState(false);
  const [forcePage, setForcePage] = useState(0);
  const [fromDate, setFromDate] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [by_search, setBy_search] = useState('');
  const [me_search, setMe_search] = useState('');
  const [agencies, setAgencies] = useState([])
  const [requests, setRequests] = useState([])
  const [requestCurrentPage, setRequestCurrentPage] = useState(1)
  const [requestHasMore, setRequestHasMore] = useState(true)
  const [requestTotal, setRequestTotal] = useState(0)
  const [requestTotalPages, setRequestTotalPages] = useState(0)
  const [allRequests, setAllRequests] = useState([])
  const [totalRequestPages, setTotalRequestPages] = useState(0)
  const [agencyUsers, setAgencyUsers] = useState([])
  const [agency, setAgency] = useState(null)
  const [tags, setTags] = useState([])


  return (
    <>
      <StateContext.Provider value={{
        detailModal, setDetailModal,
        notifications, setNotifications,
        success, setSuccess,
        modal, setModal,
        ticket, setTicket,
        token,
        tickets, setTickets,
        ticketIds, setTicketIds,
        employees, setEmployees,
        loading, setLoading,
        FCM_token, setFCM_token,
        confirm, setConfirm,
        allTickets, setAllTickets,
        detail, setDetail,
        reminderData, setReminderData,
        groupDetails, setGroupDetails,
        groups, setGroups, userUpdateId,
        setUserUpdateId, delayRequest,
        setDelayRequest, sortOrder,
        setSortOrder, toDate,
        setToDate, sortBy,
        fromDate, setFromDate,
        setSortBy, filterItem, setFilterItem, filters, setFilters, filter, setFilter,
        setCurrentPage, totalPages, setTotalPages, currentPage,
        totalTickets, setTotalTickets, isLoading, setIsLoading, hasMore, setHasMore,
        fetching, setFetching, load, setLoad, forcePage, setForcePage, searchValue, setSearchValue,
        by_search, setBy_search, me_search, setMe_search, agencies, setAgencies, requests, setRequests,
        requestCurrentPage, setRequestCurrentPage, setCurrentPage, requestHasMore, setRequestHasMore,
        requestTotal, setRequestTotal, requestTotalPages, setRequestTotalPages, allRequests, setAllRequests,
        totalRequestPages, setTotalRequestPages, setAgencyUsers, agencyUsers, agency, setAgency, tags, setTags
      }}>
        {props.children}
      </StateContext.Provider>
    </>
  )
}

export default State
